<div class="row align-items-end">
  <div class="col-sm-6 text-center" *ngIf="!isGettingSemirremolque">
    <div>
      <small id="semirremolque-dates" class="text-muted">
        Creado: {{ semirremolque.createdAt | dateFormat | dateWithoutSeconds }}
        <br />
        Actualizado:
        {{ semirremolque.updatedAt | dateFormat | dateWithoutSeconds }}
      </small>
    </div>
    <div class="divCenter gap-12">
      <button
        id="semirremolque-details-reject"
        type="button"
        class="btn btn-outline-danger-new my-2"
        (click)="onRejectSemirremolque()"
        *ngIf="semirremolqueCanBeRejected && showButton('reject')"
      >
        Rechazar
      </button>
      <button
        id="semirremolque-details-approve"
        type="button"
        class="btn btn-outline-primary-new my-2"
        (click)="onApproveSemirremolque()"
        *ngIf="semirremolqueNeedsApproval && showButton('approve')"
      >
        Aprobar
      </button>
    </div>
  </div>
  <div class="col-sm-6 text-end">
    <div class="btn-group" style="padding-top: 60px">
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-outline-primary dropdownButton mx-2 dropdownButton-new"
          id="semirremolque-details-actions"
          *ngIf="!isGettingSemirremolque && showButton('actions')"
          ngbDropdownToggle
        >
          Acciones
          <span class="material-symbols-outlined"> keyboard_arrow_down </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownActions">
          <a
            id="semirremolque-details-edit"
            *ngIf="!isGettingSemirremolque && showButton('edit')"
            (click)="onEditSemirremolque()"
            class="dropdown-item"
            ngbDropdownItem
          >
            Actualizar documentos</a
          >
          <a
            id="semirremolque-details-reprocesing"
            *ngIf="!isGettingSemirremolque && isAdmin"
            [disabled]="!isReprocesingAvailable()"
            (click)="OnReprocesiing()"
            class="dropdown-item"
            ngbDropdownItem
            >Reprocesar</a
          >
          <div class="dropdown-divider"></div>
          <a
            id="semirremolque-details-archive"
            *ngIf="!isGettingSemirremolque && showButton('archive')"
            (click)="onArchiveSemirremolque()"
            ngbDropdownItem
          >
            Archivar</a
          >
          <a
            id="semirremolque-details-delete"
            *ngIf="!isGettingSemirremolque && showButton('delete')"
            (click)="onDeleteSemirremolque()"
            ngbDropdownItem
          >
            Borrar</a
          >
        </div>
      </div>
      <button
        id="semirremolque-details-refresh"
        class="btn-refresh-details"
        *ngIf="!isGettingSemirremolque"
        (click)="onRefreshSemirremolque()"
      >
        <span class="material-symbols-outlined"> refresh </span>
      </button>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-sm-6 text-center my-5" *ngIf="isGettingSemirremolque">
    <app-spinner message="Cargando detalles del vehículo..."></app-spinner>
  </div>
  <div
    class="col-sm-6 box-details-cab"
    [ngStyle]="{ border: '3px solid ' + getColor() }"
    *ngIf="!isGettingSemirremolque"
  >
    <div class="div-box-sap-id">
      <h4 [ngStyle]="{ color: getColor(), 'font-weight': 'bold' }">
        SAP ID: {{ semirremolque.sapId! | sapId }}
      </h4>
    </div>
    <div style="display: inline">
      <p>
        <strong>Transportista</strong>: <br />{{ semirremolque.carrier!.name }}
      </p>
      <p><strong>Patente</strong>: <br />{{ semirremolque.licensePlate }}</p>
      <p>
        <strong>Acoplamiento</strong>: <br />
        <span *ngIf="semirremolqueIsCoupled"
          >{{ coupleType }} {{ coupleIdentification }}</span
        >
        <span *ngIf="!semirremolqueIsCoupled">Desacoplado</span>
      </p>
    </div>
    <div *ngIf="!semirremolqueIsCoupled" class="text-danger divCenter">
      <p><strong>Desacoplado</strong></p>
    </div>
    <div class="divCenter" style="text-align: center">
      <p *ngIf="showBlockingMotives">
        <strong
          >Bloqueado el
          {{
            semirremolque.lastStatusInformedAt || semirremolque.updatedAt
              | dateFormat
              | dateWithoutSeconds
          }}
          por</strong
        >:<br />
        <span
          class="badge border rounded-4 text-bg-light mx-1"
          *ngFor="let motive of semirremolque.blockingMotives"
        >
          {{ motive }}
        </span>
      </p>
    </div>

    <div class="divCenter">
      <h5>
        <span
          class="badge"
          [ngStyle]="{ 'background-color': getColor() }"
          style="width: 200px; border-radius: 60px"
        >
          <span>
            <img
              [src]="getImageSrc(semirremolque.status)"
              height="25"
              width="25"
              alt="Estado"
            />
          </span>
          {{ semirremolque.status | master : "VEHICLES#STATUSES" }}</span
        >
      </h5>
      <div *ngIf="hasComment">
        <label
          class="custom-file-upload pt-2 mx-1 float-end text-secondary"
          style="cursor: pointer"
        >
          <a id="entity-comment" title="Comentario" (click)="onViewComment()">
            <span class="material-symbols-outlined">comment</span>
          </a>
        </label>
      </div>
    </div>
    <div class="divCenter mb-2" *ngIf="hasComment && showComment">
      <div class="collapse comment" [ngClass]="showCommentClass()">
        <div class="card card-body">
          {{ semirremolque.comment }}
        </div>
      </div>
    </div>

    <div class="divCenter">
      <h6>
        <span
          class="badge border rounded-4 text-bg-light"
          *ngIf="hasToExpireDocuments()"
        >
          <span class="badge border rounded-circle text-bg-light">{{
            semirremolque.documentsToExpire
          }}</span>
          por vencer</span
        >
      </h6>
      <h6>
        <span
          class="badge border rounded-4 text-bg-light"
          *ngIf="hasExpiredDocuments()"
        >
          <span class="badge border rounded-circle text-bg-light">{{
            semirremolque.documentsExpired
          }}</span>
          vencido</span
        >
      </h6>
    </div>

    <div ngbAccordion style="padding: 10px">
      <div ngbAccordionItem [collapsed]="true">
        <h2 ngbAccordionHeader>
          <button id="semirremolque-details-accordion" ngbAccordionButton>
            Ver detalles
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody class="table-container">
            <ng-template>
              <table class="table table-hover">
                <caption>
                  Detalles del Vehículo
                </caption>
                <tbody>
                  <tr>
                    <th scope="row">Centro</th>
                    <td>
                      {{ semirremolque.originalCenter! | master : "CENTERS" }}
                    </td>
                  </tr>

                  <tr>
                    <th class="align-middle" scope="row">Centro de Apoyo</th>
                    <td>
                      <div>
                        <label
                          *ngIf="showButton('edit-center')"
                          class="float-start me-1"
                          style="cursor: pointer"
                        >
                          <a
                            id="update-center"
                            title="Actualizar Centro de Apoyo"
                            (click)="onUpdateSemirremolque()"
                          >
                            <span
                              class="material-symbols-outlined text-secondary"
                              >edit_square</span
                            >
                          </a>
                        </label>
                        {{ semirremolque.center | master : "CENTERS" }}
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th scope="row">Sub-Negocio</th>
                    <td>
                      {{
                        semirremolque.subBusiness | master : "SUB_BUSINESSES"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Marca</th>
                    <td>
                      {{ semirremolque.brand | master : "VEHICLES#BRANDS" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Modelo</th>
                    <td>{{ semirremolque.model }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Año de Fabricación</th>
                    <td>{{ semirremolque.year }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Antigüedad</th>
                    <td>
                      {{ currentYear - semirremolque.year }} año{{
                        currentYear - semirremolque.year === 1 ? "" : "s"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Color</th>
                    <td>
                      {{ semirremolque.color | master : "VEHICLES#COLORS" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Tipo</th>
                    <td>
                      {{ semirremolque.type | master : "SEMIRREMOLQUES#TYPES" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Capacidad</th>
                    <td>
                      {{
                        semirremolque.capacity
                          | master : "SEMIRREMOLQUES#CAPACITIES"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Máximo de Pallets</th>
                    <td>{{ semirremolque.maximumPalletCapacity }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Alto x Ancho x Largo (metros)</th>
                    <td>
                      {{ semirremolque.height }} x {{ semirremolque.width }} x
                      {{ semirremolque.length }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Rampa</th>
                    <td>
                      {{
                        semirremolque.rampType!
                          | master : "SEMIRREMOLQUES#RAMP_TYPES"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Usado en Minería</th>
                    <td>{{ semirremolque.forMining ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Acreditación Ranchera</th>
                    <td>
                      {{ semirremolque.hasRanchAccreditation ? "Sí" : "No" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Es Spot</th>
                    <td>{{ semirremolque.isSpot ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Código MOP</th>
                    <td>{{ semirremolque.MOPCode }}</td>
                  </tr>
                  <tr>
                    <th scope="row">GPS IMEI</th>
                    <td>{{ semirremolque.gpsImei }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Cámara IMEI</th>
                    <td>{{ semirremolque.cameraImei }}</td>
                  </tr>

                  <tr *ngIf="semirremolque.archiveId">
                    <th scope="row">Archivo</th>
                    <td>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                      >
                        <a
                          id="semirremolque-archive-details"
                          title="Visualizar Detalle"
                          (click)="onViewArchiveDetails()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >docs</span
                          >
                        </a>
                      </label>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                        *ngIf="hasDocumentOnArchive()"
                      >
                        <a
                          id="semirremolque-preview-archive-docs"
                          title="Visualizar Documento"
                          (click)="onViewDocumentArchive()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >preview</span
                          >
                        </a>
                      </label>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                        *ngIf="hasDocumentOnArchive()"
                      >
                        <a
                          id="semirremolque-download-archive-docs"
                          title="Descargar Documento"
                          (click)="onDownloadArchiveDocument()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >download</span
                          >
                        </a>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <div id="semirremolque-agreement" *ngIf="hasAgrement" ngbAccordion>
      <app-commercial-agreements-details
        [agreement]="agreement"
        [isColapsed]="isColapsed"
      ></app-commercial-agreements-details>
    </div>
  </div>
  <div class="col-sm-6">
    <app-documents></app-documents>
  </div>
</div>

<!-- Modals -->
<ng-template #semirremolqueModal let-c="close" let-d="dismiss">
  <app-modal-with-comment
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [showCommentForm]="modalWithComment"
    [mandatoryComment]="isBeingRejected"
    [commentForm]="commentForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-with-comment>
</ng-template>

<!-- Update Attribute Modal -->
<ng-template #updateSemirremolqueAttributeModal let-c="close" let-d="dismiss">
  <app-modal-change-attributes
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [attributeForm]="updateAttributeForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-change-attributes>
</ng-template>

<!-- Archive Modal -->
<ng-template #archiveSemirremolqueModal let-c="close" let-d="dismiss">
  <app-modal-for-archiving
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [archiveForm]="archiveForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-for-archiving>
</ng-template>
<!--Archive Details Modal-->
<ng-template #semirremolqueArchiveDetailsModal let-c="close" let-d="dismiss">
  <app-modal-details
    [archive]="semirremolqueArchive?.entity"
    [updatedAt]="semirremolqueArchive?.updatedAt"
    [comment]="semirremolqueArchive?.comment"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  >
  </app-modal-details>
</ng-template>

<!--Document Viewer Modal-->
<ng-template #semirremolqueArchiveDocumentViewer let-c="close" let-d="dismiss">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ modalTitle }}</h4>
        <button
          id="document-item-modal-cross"
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross')"
        ></button>
      </div>
      <div class="modal-body">
        <div class="text-center my-5" *ngIf="isGettingURL">
          <app-spinner message="Generando Vista Previa"></app-spinner>
        </div>
        <pdf-viewer
          [src]="pdfSource"
          [render-text]="true"
          [original-size]="false"
          [fit-to-page]="true"
          (page-rendered)="pageRendered()"
          style="width: 800px; height: 70vh"
        >
        </pdf-viewer>
      </div>
      <div class="modal-footer" *ngIf="!isGettingURL">
        <button
          id="document-item-modal-accept"
          type="button"
          class="btn btn-outline-primary"
          (click)="c('Accept')"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</ng-template>
